export default {
  toasts: {
    load_error: 'Falha ao carregar as taxas',
    failed_to_save_changes: 'Falha ao guardar as alterações',
    changes_got_saved: 'Alterações guardadas',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  rates: {
    title: 'Margem de processamento',
    description:
      'Percentagem em %, mais um valor fixo e mínimo opcionais por cobrança. «Qualquer método de pagamento» aplica-se quando não existe uma taxa específica do método.',
  },
};
